module.exports = __webpack_public_path__ + "img/gallery.69629908.gif";